import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_CF_FTP_INFO = '/cf-ftp-infos';

export const SET_CF_FTP_INFO_LOADING = 'SET_CF_FTP_INFO_LOADING';
export const GO_TO_CF_FTP_INFO_CREATE = 'GO_TO_CF_FTP_INFO_CREATE';
export const GO_TO_CF_FTP_INFO_EDIT = 'GO_TO_CF_FTP_INFO_EDIT';
export const GO_TO_CF_FTP_INFO_VIEW = 'GO_TO_CF_FTP_INFO_VIEW';
export const GO_TO_CF_FTP_INFO_COPY = 'GO_TO_CF_FTP_INFO_COPY';
export const GO_TO_CF_FTP_INFO_LIST = 'GO_TO_CF_FTP_INFO_LIST';
export const GET_CF_FTP_INFO_LIST = 'GET_CF_FTP_INFO_LIST';
export const GET_CF_FTP_INFO_LIST_PENDING = 'GET_CF_FTP_INFO_LIST_PENDING';
export const GET_CF_FTP_INFO_LIST_FULFILLED = 'GET_CF_FTP_INFO_LIST_FULFILLED';
export const GET_CF_FTP_INFO = 'GET_CF_FTP_INFO';
export const GET_CF_FTP_INFO_PENDING = 'GET_CF_FTP_INFO_PENDING';
export const GET_CF_FTP_INFO_FULFILLED = 'GET_CF_FTP_INFO_FULFILLED';
export const CREATE_CF_FTP_INFO = 'CREATE_CF_FTP_INFO';
export const CREATE_CF_FTP_INFO_PENDING = 'CREATE_CF_FTP_INFO_PENDING';
export const CREATE_CF_FTP_INFO_FULFILLED = 'CREATE_CF_FTP_INFO_FULFILLED';
export const CREATE_CF_FTP_INFO_REJECTED = 'CREATE_CF_FTP_INFO_REJECTED';
export const UPDATE_CF_FTP_INFO = 'UPDATE_CF_FTP_INFO';
export const UPDATE_CF_FTP_INFO_FULFILLED = 'UPDATE_CF_FTP_INFO_FULFILLED';
export const UPDATE_CF_FTP_INFO_REJECTED = 'UPDATE_CF_FTP_INFO_REJECTED';
export const DELETE_CF_FTP_INFO = 'DELETE_CF_FTP_INFO';
export const DELETE_CF_FTP_INFO_FULFILLED = 'DELETE_CF_FTP_INFO_FULFILLED';
export const DELETE_CF_FTP_INFO_REJECTED = 'DELETE_CF_FTP_INFO_REJECTED';
export const SELECT_CF_FTP_INFO = 'SELECT_CF_FTP_INFO';
export const OPEN_CF_FTP_INFO_CREATE_POPUP = 'OPEN_CF_FTP_INFO_CREATE_POPUP';
export const CLOSE_CF_FTP_INFO_CREATE_POPUP = 'CLOSE_CF_FTP_INFO_CREATE_POPUP';

export enum CfFtpInfoPrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access',
}
export enum CfFtpInfoMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}
export interface CfFtpInfo {
  id: string,
  FTPID: string,
  IPADDR: string,
  PORT: string,
  USERNAME: string,
  USERPASSWD: string,
  DESTPATH: string,
  OPERATORID: string,
  FTPFILESIZE: string,
  FTPFILESEC: string,
  FILEMODE: 'ALLINONE' | 'CASE',
  FTPTYPE: 'FTP' | 'SFTP',
  OWNER: string,
  GROUP: string,
  ACCESS: string
}

export interface CfFtpInfoState {
  entities: CfFtpInfo[]
  selected: CfFtpInfo[],
  single: CfFtpInfo | null
  createdId: string | null
  ui: CfFtpInfosUIState
}

export interface CfFtpInfosUIState {
  isCreatePopupOpen: boolean
  isLoading: boolean
}

export interface GoToCfFtpInfoListAction extends AnyAction {
  type: typeof GO_TO_CF_FTP_INFO_LIST
}

export interface SetCfFtpInfoLoadingAction extends AnyAction {
  type: typeof SET_CF_FTP_INFO_LOADING
  payload: { isLoading: boolean }
}

export interface GetCfFtpInfoListAction extends AnyAction {
  type: typeof GET_CF_FTP_INFO_LIST
  payload: AxiosPromise<ServerResponse<CfFtpInfo>>
}

export interface GetCfFtpInfoListPendingAction extends AnyAction {
  type: typeof GET_CF_FTP_INFO_LIST_PENDING
  payload: null
}

export interface GetCfFtpInfoListFulfilledAction extends AnyAction {
  type: typeof GET_CF_FTP_INFO_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<CfFtpInfo>>
}

export interface GetCfFtpInfoAction extends AnyAction {
  type: typeof GET_CF_FTP_INFO
  payload: AxiosPromise<ServerResponse<CfFtpInfo>>
}

export interface GetCfFtpInfoPendingAction extends AnyAction {
  type: typeof GET_CF_FTP_INFO_PENDING
  payload: null
}

export interface GetCfFtpInfoFulfilledAction extends AnyAction {
  type: typeof GET_CF_FTP_INFO_FULFILLED
  payload: AxiosResponse<ServerResponse<CfFtpInfo>>
}

export interface CreateCfFtpInfoThunkAction extends ThunkAction<void, RootState, void, AnyAction> { }
export interface CreateCfFtpInfoAction extends AnyAction {
  type: typeof CREATE_CF_FTP_INFO
  payload: AxiosPromise<ServerResponse<CfFtpInfo>>
}

export interface CreateCfFtpInfoPendingAction extends AnyAction {
  type: typeof CREATE_CF_FTP_INFO_PENDING
  payload: null
}

export interface CreateCfFtpInfoFulfilledAction extends AnyAction {
  type: typeof CREATE_CF_FTP_INFO_FULFILLED
  payload: AxiosResponse<ServerResponse<CfFtpInfo>>
}

export interface CreateCfFtpInfoRejectedAction extends AnyAction {
  type: typeof CREATE_CF_FTP_INFO_REJECTED
  payload: AxiosResponse<ServerResponse<CfFtpInfo>>
}

export interface UpdateCfFtpInfoThunkAction extends ThunkAction<void, RootState, void, AnyAction> { }
export interface UpdateCfFtpInfoAction extends AnyAction {
  type: typeof UPDATE_CF_FTP_INFO
  payload: AxiosPromise<ServerResponse<CfFtpInfo>>
}

export interface UpdateCfFtpInfoFulfilledAction extends AnyAction {
  type: typeof UPDATE_CF_FTP_INFO_FULFILLED
  payload: AxiosResponse<ServerResponse<CfFtpInfo>>
}

export interface UpdateCfFtpInfoRejectedAction extends AnyAction {
  type: typeof UPDATE_CF_FTP_INFO_REJECTED
  payload: AxiosResponse<ServerResponse<CfFtpInfo>>
}

export interface DeleteCfFtpInfoThunkAction extends ThunkAction<void, RootState, void, AnyAction> { }
export interface DeleteCfFtpInfoAction extends AnyAction {
  type: typeof DELETE_CF_FTP_INFO
  payload: AxiosPromise<ServerResponse<CfFtpInfo>>
}

export interface DeleteCfFtpInfoFulfilledAction extends AnyAction {
  type: typeof DELETE_CF_FTP_INFO_FULFILLED
  payload: AxiosResponse<ServerResponse<CfFtpInfo>>
}

export interface DeleteCfFtpInfoRejectedAction extends AnyAction {
  type: typeof DELETE_CF_FTP_INFO_REJECTED
  payload: AxiosResponse<ServerResponse<CfFtpInfo>>
}

export interface SelectCfFtpInfoAction extends AnyAction {
  type: typeof SELECT_CF_FTP_INFO
  payload: CfFtpInfo[]
}

export interface OpenCfFtpInfoCreatePopupAction extends AnyAction {
  type: typeof OPEN_CF_FTP_INFO_CREATE_POPUP
  payload: { cfFtpInfo?: CfFtpInfo }
}

export interface CloseCfFtpInfoCreatePopupAction extends AnyAction {
  type: typeof CLOSE_CF_FTP_INFO_CREATE_POPUP
}

export type CfFtpInfoActionTypes =
  GoToCfFtpInfoListAction |
  SetCfFtpInfoLoadingAction |
  GetCfFtpInfoListAction |
  GetCfFtpInfoListPendingAction |
  GetCfFtpInfoListFulfilledAction |
  GetCfFtpInfoAction |
  GetCfFtpInfoPendingAction |
  GetCfFtpInfoFulfilledAction |
  CreateCfFtpInfoAction |
  CreateCfFtpInfoPendingAction |
  CreateCfFtpInfoFulfilledAction |
  CreateCfFtpInfoRejectedAction |
  UpdateCfFtpInfoAction |
  UpdateCfFtpInfoFulfilledAction |
  UpdateCfFtpInfoRejectedAction |
  DeleteCfFtpInfoAction |
  DeleteCfFtpInfoFulfilledAction |
  DeleteCfFtpInfoRejectedAction |
  SelectCfFtpInfoAction |
  OpenCfFtpInfoCreatePopupAction |
  CloseCfFtpInfoCreatePopupAction;
